<template>
    <div v-route-title="basicInfo?basicInfo.name:'公司信息'">
        <div class="yq-company-details" v-if="basicInfo">
            <div class="yq-company-head">
                <img class="yq-company-logo" :src="basicInfo.companyLogoUrl">
                <div>
                    <div class="yq-company-name">{{basicInfo.name}}</div>
                    <div class="yq-company-fields">
                        <div v-if="basicInfo.shortName">简称：{{basicInfo.shortName}}</div>
                        <div v-if="basicInfo.location">注册地：{{basicInfo.location}}</div>
                        <div v-if="basicInfo.establishDate">成立时间：{{basicInfo.establishDate}}</div>
                    </div>
                </div>
            </div>
            <div class="yq-company-body">
                <div class="yq-company-section" v-if="icBasicInfo">
                    <div class="yq-company-section-head">
                        <div class="yq-company-section-head-anchor"></div>
                        <div class="yq-company-section-head-title">工商信息</div>
                    </div>
                    <div class="yq-company-section-body">
                        <table class="yq-company-table">
                            <tr>
                                <td class="yq-company-table-label" width="120">注册资本：</td>
                                <td class="yq-company-table-value" width="300">{{icBasicInfo.registeredCapital}}</td>
                                <td class="yq-company-table-label" width="120">实缴资本：</td>
                                <td class="yq-company-table-value" width="264">{{icBasicInfo.receivedRegisteredFunds}}</td>
                                <td class="yq-company-table-label" width="148">经营状态：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.enterpriseState}}</td>
                            </tr>
                            <tr>
                                <td class="yq-company-table-label">法人姓名：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.legalPersonName}}</td>
                                <td class="yq-company-table-label">成立日期：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.establishDate}}</td>
                                <td class="yq-company-table-label">公司类型：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.typeName}}</td>
                            </tr>
                            <tr>
                                <td class="yq-company-table-label">注册号：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.registrationNumber}}</td>
                                <td class="yq-company-table-label">纳税人识别号：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.taxpayerIN}}</td>
                                <td class="yq-company-table-label">统一社会信用代码：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.creditCode}}</td>
                            </tr>
                            <tr>
                                <td class="yq-company-table-label">英文名：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.companyNameEn}}</td>
                                <td class="yq-company-table-label">组织机构代码：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.parse}}</td>
                                <td class="yq-company-table-label">登记机关：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.registrationAuthority}}</td>
                            </tr>
                            <tr>
                                <td class="yq-company-table-label">营业起始日期：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.businessTermStartDate}}</td>
                                <td class="yq-company-table-label">营业终止日期：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.businessTermEndDate}}</td>
                                <td class="yq-company-table-label">核准日期：</td>
                                <td class="yq-company-table-value">{{icBasicInfo.approvalDate}}</td>
                            </tr>
                            <tr>
                                <td class="yq-company-table-label">注册地址：</td>
                                <td class="yq-company-table-value" colspan="5">{{icBasicInfo.registeredAddress}}</td>
                            </tr>
                            <tr>
                                <td class="yq-company-table-label">经营范围：</td>
                                <td class="yq-company-table-value" colspan="5">{{icBasicInfo.businessScope}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="yq-company-section">
                    <div class="yq-company-section-head">
                        <div class="yq-company-section-head-anchor"></div>
                        <div class="yq-company-section-head-title">公司介绍</div>
                    </div>
                    <div class="yq-company-section-body">
                        <div class="yq-company-text">{{basicInfo.description}}</div>
                    </div>
                </div>
                <div class="yq-company-section" v-if="stockDetails">
                    <div class="yq-company-section-head">
                        <div class="yq-company-section-head-anchor"></div>
                        <div class="yq-company-section-head-title">证劵资料</div>
                    </div>
                    <div class="yq-company-section-body">
                        <table class="yq-company-table">
                            <tr>
                                <td width="321">A股：{{stockDetails.agjc}}({{stockDetails.agdm}})</td>
                                <td width="363">上市交易所：{{stockDetails.ssjys}}</td>
                                <td>所属证监会行业：{{stockDetails.sszjhhy}}</td>
                            </tr>
                            <tr>
                                <td>B股：{{stockDetails.bgjc}}({{stockDetails.bgdm}})</td>
                                <td>注册资本（元）：{{stockDetails.zczb}}</td>
                                <td>工商登记：{{stockDetails.gsdj}}</td>
                            </tr>
                            <tr>
                                <td>法人代表：{{stockDetails.frdb}}</td>
                                <td>联系电话：{{stockDetails.lxdh}}</td>
                                <td>会计事务所：{{stockDetails.kjssws}}</td>
                            </tr>
                            <tr>
                                <td>董事长：{{stockDetails.dsz}}</td>
                                <td>公司传真：{{stockDetails.cz}}</td>
                                <td>律师事务所：{{stockDetails.lssws}}</td>
                            </tr>
                            <tr>
                                <td>董秘：{{stockDetails.dm}}</td>
                                <td>电子信箱：{{stockDetails.dzxx}}</td>
                                <td>邮政编码：{{stockDetails.yzbm}}</td>
                            </tr>
                            <tr>
                                <td>证券事务代表：{{stockDetails.zqswdb}}</td>
                                <td>管理人员人数：{{stockDetails.glryrs}}</td>
                                <td>办公地址：{{stockDetails.bgdz}}</td>
                            </tr>
                            <tr>
                                <td>独立董事：{{stockDetails.dlds}}</td>
                                <td>雇员人数：{{stockDetails.gyrs}}</td>
                                <td>注册地址：{{stockDetails.zcdz}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="yq-company-section">
                    <div class="yq-company-section-head">
                        <div class="yq-company-section-head-anchor"></div>
                        <div class="yq-company-section-head-title">风险预警</div>
                    </div>
                    <div class="yq-company-section-body">
                        <el-tabs class="yq-tabs" v-model="activeType" @tab-click="handleTypeTabClick">
                            <el-tab-pane v-for="type in types" :key="type.title"
                                         :label="type.title+(type.indicator>0?('('+type.indicator+')'):'')"
                                         :name="type.title">
                                <div v-if="eventData">
                                    <div v-if="activeType==='舆情'">
                                        <div v-for="event in eventData.content" :key="event.id" class="yq-company-monitor-news">
                                            <div class="yq-company-monitor-news-headline">
                                                <div class="yq-company-monitor-news-title" @click="showNews(event.sourceId)">{{event.summary.title}}</div>
                                            </div>
                                            <div class="yq-company-monitor-news-fields">
                                                <div class="yq-company-monitor-news-company">相关公司：{{event.companyName}}</div>
                                                <div class="yq-company-monitor-news-date">{{event.publishDate}}</div>
                                                <div class="yq-company-monitor-news-site">来自：{{event.summary.site}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <el-table v-else-if="activeType==='工商变更'" :key="activeType" class="yq-table" :data="eventData.content" style="width: 100%">
                                        <el-table-column
                                                label="序号"
                                                type="index"
                                                :index="indexMethod" width="60">
                                        </el-table-column>
                                        <el-table-column
                                                prop="companyName"
                                                label="公司名称">
                                        </el-table-column>
                                        <el-table-column
                                                label="变更事项">
                                            <span slot-scope="scope">{{scope.row.summary.changeMatter}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="变更前内容">
                                            <span slot-scope="scope">{{scope.row.summary.changeBefore}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="变更后内容">
                                            <span slot-scope="scope">{{scope.row.summary.changeAfter}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                prop="publishDate"
                                                label="变更时间" width="120">
                                        </el-table-column>
                                    </el-table>
                                    <el-table v-else-if="activeType==='行政处罚'" :key="activeType" class="yq-table" :data="eventData.content" style="width: 100%">
                                        <el-table-column
                                                label="序号"
                                                type="index"
                                                :index="indexMethod" width="60">
                                        </el-table-column>
                                        <el-table-column
                                                prop="companyName"
                                                label="公司名称">
                                        </el-table-column>
                                        <el-table-column
                                                label="公告标题">
                                            <el-link slot-scope="scope" @click="showPenaltyDetails(scope.row.sourceId)">{{scope.row.summary.docTitle}}</el-link>
                                        </el-table-column>
                                        <el-table-column
                                                label="处罚机关">
                                            <span slot-scope="scope">{{scope.row.summary.mechanism}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="处罚文号">
                                            <span slot-scope="scope">{{scope.row.summary.docNo}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="处罚类型">
                                            <span slot-scope="scope">{{scope.row.summary.types}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="处罚日期" width="120">
                                            <span slot-scope="scope">{{scope.row.summary.penaltyDate}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                prop="publishDate"
                                                label="公告日期" width="120">
                                        </el-table-column>
                                    </el-table>
                                    <el-table v-else-if="activeType==='裁判文书'" :key="activeType" class="yq-table" :data="eventData.content" style="width: 100%">
                                        <el-table-column
                                                label="序号"
                                                type="index"
                                                :index="indexMethod" width="60">
                                        </el-table-column>
                                        <el-table-column
                                                prop="companyName"
                                                label="公司名称">
                                        </el-table-column>
                                        <el-table-column
                                                label="文书名">
                                            <span slot-scope="scope">{{scope.row.summary.wenshuming}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="文书号">
                                            <span slot-scope="scope">{{scope.row.summary.wenshuhao}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="案件类型">
                                            <span slot-scope="scope">{{scope.row.summary.type}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="所在城市">
                                            <span slot-scope="scope">{{scope.row.summary.city}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                prop="publishDate"
                                                label="公告日期" width="120">
                                        </el-table-column>
                                    </el-table>
                                    <el-table v-else-if="activeType==='开庭公告'" :key="activeType" class="yq-table" :data="eventData.content" style="width: 100%">
                                        <el-table-column
                                                label="序号"
                                                type="index"
                                                :index="indexMethod" width="60">
                                        </el-table-column>
                                        <el-table-column
                                                prop="companyName"
                                                label="公司名称">
                                        </el-table-column>
                                        <el-table-column
                                                label="法院名称">
                                            <span slot-scope="scope">{{scope.row.summary.courtName}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="公告标题">
                                            <span slot-scope="scope">{{scope.row.summary.title}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                prop="publishDate"
                                                label="公告日期" width="120">
                                        </el-table-column>
                                    </el-table>
                                    <el-table v-else-if="activeType==='失信人'" :key="activeType" class="yq-table" :data="eventData.content" style="width: 100%">
                                        <el-table-column
                                                label="序号"
                                                type="index"
                                                :index="indexMethod" width="60">
                                        </el-table-column>
                                        <el-table-column
                                                prop="companyName"
                                                label="公司名称">
                                        </el-table-column>
                                        <el-table-column
                                                label="案号">
                                            <span slot-scope="scope">{{scope.row.summary.caseCode}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="履行状态">
                                            <span slot-scope="scope">{{scope.row.summary.performance}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="执行依据">
                                            <span slot-scope="scope">{{scope.row.summary.gistCid}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                label="执行法院">
                                            <span slot-scope="scope">{{scope.row.summary.courtName}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                prop="publishDate"
                                                label="公告日期" width="120">
                                        </el-table-column>
                                    </el-table>
                                    <el-table v-else-if="activeType==='资产负债率过高'" :key="activeType" class="yq-table" :data="eventData.content" style="width: 100%">
                                        <el-table-column
                                                label="序号"
                                                type="index"
                                                :index="indexMethod" width="60">
                                        </el-table-column>
                                        <el-table-column
                                                prop="companyName"
                                                label="公司名称">
                                        </el-table-column>
                                        <el-table-column
                                                label="资产负债率">
                                            <span slot-scope="scope">{{scope.row.summary.zcfzl}}</span>
                                        </el-table-column>
                                        <el-table-column
                                                prop="publishDate"
                                                label="公告日期" width="120">
                                        </el-table-column>
                                    </el-table>
                                    <el-pagination
                                            layout="prev, pager, next" background
                                            :total="eventData.totalElements" :current-page="eventData.number+1"
                                            @current-change="fetchEventData($event)">
                                    </el-pagination>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <div class="yq-company-section">
                    <div class="yq-company-section-head">
                        <div class="yq-company-section-head-anchor"></div>
                        <div class="yq-company-section-head-title">风险时间线</div>
                    </div>
                    <div class="yq-company-section-body">
                        <div class="yq-horizontal-timeline">
                            <div class="yq-horizontal-timeline-item" v-for="event in latestEvents" :key="event.id">
                                <div class="yq-horizontal-timeline-line"></div>
                                <div class="yq-horizontal-timeline-circle"></div>
                                <div class="yq-horizontal-timeline-body">
                                    <div class="yq-horizontal-timeline-time">{{event.publishDate}}</div>
                                    <div class="yq-horizontal-timeline-content">{{event.type}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import companyMonitorService from '../service/company_monitor'
    import fileService from '../service/file'

    export default {
        name: "Penalty",
        props: {
            id: String
        },
        data(){
            return {
                basicInfo: null,
                icBasicInfo: null,
                stockDetails: null,
                activeType: '舆情',
                types: [
                    {title:'舆情',indicator:0},
                    {title:'工商变更',indicator:0},
                    {title:'行政处罚',indicator:0},
                    {title:'裁判文书',indicator:0},
                    {title:'开庭公告',indicator:0},
                    {title:'失信人',indicator:0},
                    {title:'资产负债率过高',indicator:0}
                ],
                eventData: null,
                latestEvents: []
            }
        },
        created(){
            this.init()
        },
        methods: {
            async init(){
                let response = await companyMonitorService.getDpsCompanyBasicInfo(this.id)
                if(response.data.companyLogo){
                    response.data.companyLogoUrl = fileService.getDpsFileUrl(response.data.companyLogo)
                }
                this.basicInfo = response.data
                response = await companyMonitorService.getDpsCompanyIcBasicInfo(this.id)
                this.icBasicInfo = response.data
                response = await companyMonitorService.getDpsCompanyStockDetails(this.id)
                this.stockDetails = response.data
                response = await companyMonitorService.countEventsByType({companyId:this.id})
                for(const item of response.data.data){
                    for(const type of this.types){
                        if(item.key===type.title){
                            type.indicator=item.value
                            break
                        }
                    }
                }
                await this.fetchEventData(1)
                response = await companyMonitorService.listCompanyRiskEvents({page: 0, size: 11, companyId: this.id, sort: 'publishDate,desc'})
                this.latestEvents = response.data.data.content.reverse()

            },
            handleTypeTabClick(){
                this.eventData = null
                this.fetchEventData(1)
            },
            async fetchEventData(page) {
                const params = {page: page - 1, size: 10, companyId: this.id, type: this.activeType}
                const response = await companyMonitorService.listCompanyRiskEvents(params)
                this.eventData = response.data.data
            },
            indexMethod(index) {
                return this.eventData.number * this.eventData.size + index + 1
            },
            showPenaltyDetails(id) {
                const url = [document.location.origin, document.location.pathname,
                    '#/main/penalties/', encodeURIComponent(id)
                ]
                window.open(url.join(''), '_blank')
            },
            showNews(sid) {
                const url = [document.location.origin, document.location.pathname,
                    '#/main/company-alarm-news/', encodeURIComponent(sid)
                ]
                window.open(url.join(''), '_blank')
            }
        }
    }
</script>

<style scoped>

</style>
